module.exports = __webpack_public_path__ + "6c140432b49ba6ed56c0e6a4d1abe681.png";